const routes = [
    { name: "user_info", path: "/index", component: () => import("@/views/account/user.vue") },
    { name: "user_setting", path: "/setting", component: () => import("@/views/account/setting.vue") },
    {
        name: "user_setting_company",
        path: "/setting/company",
        component: () => import("@/views/account/setting_company.vue"),
    },
    {
        name: "user_setting_about",
        path: "/setting/about",
        component: () => import("@/views/account/setting_about.vue"),
    },
    {
        name: "user_setting_agreement",
        path: "/setting/agreement",
        component: () => import("@/views/account/setting_legal.vue"),
        meta: { legalType: "agreement" },
    },
    {
        name: "user_setting_privacy",
        path: "/setting/privacy",
        component: () => import("@/views/account/setting_legal.vue"),
        meta: { legalType: "privacy" },
    },
    {
        name: "user_setting_open_source",
        path: "/setting/open-source",
        component: () => import("@/views/account/setting_legal.vue"),
        meta: { legalType: "openSource" },
    },
    { name: "user_messages", path: "/i/message", component: () => import("@/views/account/message.vue") },
    { name: "user_email", path: "/i/email", component: () => import("@/views/account/email.vue") },
    { name: "user_wechat", path: "/i/wxmp", component: () => import("@/views/account/wechat.vue") },
    {
        name: "email_verify",
        path: "/account/email/verify",
        component: () => import("@/views/account/email_verify.vue"),
    },
];

export default routes;
